// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.video-form__textarea .sk-input__textarea {\n  min-height: 80px;\n}\n.video-form .sk-select,\n.video-form .sk-input__textarea,\n.video-form .sk-input__input {\n  background-color: #fff;\n}\n", ""]);
// Exports
module.exports = exports;
